export const initialState = {
  isReady: false,
  inProduction: true,
  issuer: null as string,
  clientId: null as string,
  isSwaggerEnabled: false,
  productCode: null as number,
  publicKeyDidomi: null as string,
  offerCode: null as string,
  clienHomeUrl: null as string,
  cdiscountZenUrl: null as string,
  spbInsuredUrl: null as string,
  noticeIdDidomi: null as string,
  countries: [],
  title: [],
  steps: null as {
    part: string[];
    pro: string[];
  },
  offer: null as {
    withoutOffer: boolean,
    defaultOffer: string
  },
  languages: [],
  pendingSubscription: false,
  recaptchaActivated: false,
  recaptchaSiteKey: '',
  legalReflectionPeriodInMinutes: null as number,
  requiredFields: [],
  showDownloadDocsBtn: false,
};

export type ConfigState = Readonly<typeof initialState>;
